import { ApiHandler } from '../api-handler';
import { ApiEndpoints, HttpMethod } from '../constants';
import type { CheckoutSessionApiResponse, PortalSessionApiResponse, StripeProductsApiResponse } from '../platform/types';
import type { GeneralApiResponse } from '../types';
import type { SubscriptionDetail, InvoiceItem } from '../platform/types';

type SubscriptionApiResponse = GeneralApiResponse<SubscriptionDetail | null>;
type InvoicesApiResponse = GeneralApiResponse<InvoiceItem[]>;

export const BillingApi = {
  getProducts: () =>
    ApiHandler.makeApiRequest<StripeProductsApiResponse>({
      endpoint: ApiEndpoints.Billing.Products,
      method: HttpMethod.Get,
      rejectOnError: true,
    }),

  createCheckoutSession: (priceId: string) =>
    ApiHandler.makeApiRequest<CheckoutSessionApiResponse, { priceId: string }>({
      endpoint: ApiEndpoints.Billing.CheckoutSession,
      method: HttpMethod.Post,
      rejectOnError: true,
      data: { priceId },
    }),

  getSubscription: () =>
    ApiHandler.makeApiRequest<SubscriptionApiResponse>({
      endpoint: ApiEndpoints.Billing.Subscription,
      method: HttpMethod.Get,
      rejectOnError: true,
    }),

  getInvoices: () =>
    ApiHandler.makeApiRequest<InvoicesApiResponse>({
      endpoint: ApiEndpoints.Billing.Invoices,
      method: HttpMethod.Get,
      rejectOnError: true,
    }),

  createCustomerPortal: () =>
    ApiHandler.makeApiRequest<PortalSessionApiResponse>({
      endpoint: ApiEndpoints.Billing.CustomerPortal,
      method: HttpMethod.Post,
      rejectOnError: true,
    }),

  cancelSubscription: () =>
    ApiHandler.makeApiRequest<GeneralApiResponse>({
      endpoint: ApiEndpoints.Billing.Cancel,
      method: HttpMethod.Post,
      rejectOnError: true,
    }),

  resubscribe: () =>
    ApiHandler.makeApiRequest<GeneralApiResponse>({
      endpoint: ApiEndpoints.Billing.Resubscribe,
      method: HttpMethod.Post,
      rejectOnError: true,
    }),

  updateClinicProfile: (data: Record<string, unknown>) =>
    ApiHandler.makeApiRequest<GeneralApiResponse, Record<string, unknown>>({
      endpoint: ApiEndpoints.Billing.ClinicProfile,
      method: HttpMethod.Put,
      rejectOnError: true,
      data,
    }),
} as const;
